import { useCallback } from 'react';

import { useEditorAnnotations } from '@confluence/inline-comments-hooks/entry-points/useEditorAnnotations';
import { useRendererActions } from '@confluence/renderer-actions/entry-points/RendererActionsContext';

import { commentIsDangling } from '../utils/unreadCommentsUtils';

export interface UseIsDanglingCallbackProps {
	pageMode: 'view' | 'edit';
}

export interface UseIsDanglingCallbackResult {
	isDanglingCallback: (markerRef: string | null | undefined) => boolean;
}

export const useIsDanglingCallback = ({
	pageMode,
}: UseIsDanglingCallbackProps): UseIsDanglingCallbackResult => {
	const [editorAnnotationsState] = useEditorAnnotations();
	const { annotations } = editorAnnotationsState;

	const rendererActionsResult = useRendererActions();
	const { rendererActions } = rendererActionsResult || {};

	const isDanglingCallback = useCallback(
		(markerRef: string | null | undefined) => {
			return commentIsDangling({
				pageMode,
				annotationsInEditorDoc: new Set(annotations),
				rendererAnnotations: new Set(
					rendererActions
						?.getAnnotationMarks()
						?.map((ann) => ann.attrs.id)
						.filter(Boolean) || [],
				),
			})(markerRef);
		},
		[annotations, rendererActions, pageMode],
	);

	return {
		isDanglingCallback,
	};
};
